import type { LegDTO } from '@/types/dto/agent';

const carrierReplacements: Record<string, LegDTO['carrier']> = {
  // BR-57741 WS 2.0: TIF brand specific carrier logo.
  // Replace Trenitalia France logo with one for Frecciarossa and hide carrier name.
  // Note - Carrier code is different in initial offer search (tif:0083) and later in booking (1328).
  '1328': {
    code: '1328',
    name: '', // 'Trenitalia France',
    logoUrl: '/frecciarossa.svg',
  },
  'tif:0083': {
    code: 'tif:0083',
    name: '', // 'Trenitalia France',
    logoUrl: '/frecciarossa.svg',
  },
};

export const replaceCarrier = (
  carrier: LegDTO['carrier']
): LegDTO['carrier'] => {
  if (carrier?.code && carrier?.code in carrierReplacements) {
    return carrierReplacements[carrier?.code];
  }
  return carrier;
};
